export const LINEAR_LOADER_CONTAINER_ID_NAME = "LINEAR_LOADER_CONTAINER_ID_NAME";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=in.xarothi.student";
export const APP_STORE_URL = "https://apps.apple.com/in/app/xarothi-super-prep/id6780171954";